import { render, staticRenderFns } from "./CardHistoricoStatus.vue?vue&type=template&id=31dcf7a4&scoped=true"
import script from "./CardHistoricoStatus.vue?vue&type=script&lang=js"
export * from "./CardHistoricoStatus.vue?vue&type=script&lang=js"
import style0 from "./CardHistoricoStatus.vue?vue&type=style&index=0&id=31dcf7a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dcf7a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31dcf7a4')) {
      api.createRecord('31dcf7a4', component.options)
    } else {
      api.reload('31dcf7a4', component.options)
    }
    module.hot.accept("./CardHistoricoStatus.vue?vue&type=template&id=31dcf7a4&scoped=true", function () {
      api.rerender('31dcf7a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CardHistoricoStatus.vue"
export default component.exports